var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsightsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_547_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5714 23.2857C41.5714 12.6345 32.9369 4 22.2857 4C11.6345 4 3 12.6345 3 23.2857C3 33.9369 11.6345 42.5714 22.2857 42.5714C32.9369 42.5714 41.5714 33.9369 41.5714 23.2857Z",
    fill: "#BDDBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7857 22.5C41.7857 11.8488 33.1512 3.21429 22.4999 3.21429C11.8487 3.21429 3.21423 11.8488 3.21423 22.5C3.21423 33.1512 11.8487 41.7857 22.4999 41.7857C33.1512 41.7857 41.7857 33.1512 41.7857 22.5Z",
    stroke: "#D2E7FF",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 23H19V31H14L14 23Z",
    fill: "#BDDBFF",
    stroke: "#1E3584",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_547_79",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 18,
    width: 7,
    height: 14,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 18,
    width: 7,
    height: 14,
    rx: 1,
    fill: "#BDDBFF",
    stroke: "#1E3584",
    strokeWidth: 4,
    mask: "url(#path-4-inside-1_547_79)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_547_79",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 12,
    width: 7,
    height: 20,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 12,
    width: 7,
    height: 20,
    rx: 1,
    fill: "#BDDBFF",
    stroke: "#1E3584",
    strokeWidth: 4,
    mask: "url(#path-5-inside-2_547_79)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_547_79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsIcon);
export default __webpack_public_path__ + "static/media/insights_icon.8b78a5993d104c2ddcff6418687f8cf5.svg";
export { ForwardRef as ReactComponent };